import { useEmailThreadContext } from '@shared/contexts/pluginContexts/EmailThreadContext';
import { JobType } from '@shared/generated/graphql';
import { useAnalytics } from '@shared/hooks/useAnalytics';

export const useBuildFromEmail = () => {
  const { createOrder, createQuote, threadJobs } = useEmailThreadContext();
  const { track } = useAnalytics();

  const createJob = async (jobType: JobType, buildHint?: string) => {
    switch (jobType) {
      case JobType.ORDERS:
        track('Clicked Build Order', {});
        return createOrder.call();
      case JobType.QUOTES:
        track('Clicked Create Quote', {});
        return createQuote.call({ buildHint });
      default:
        throw new Error(`Invalid job type: ${jobType}`);
    }
  };

  const buildFromEmail = async (jobType: JobType, buildHint?: string) => {
    const job = await createJob(jobType, buildHint);
    if (job) threadJobs.storeJobType(jobType, job.id);
    return job;
  };

  return {
    buildFromEmail,
    isBuilding: createOrder.loading || createQuote.loading,
  };
};
